module.exports = __webpack_public_path__ + "static/img/A2E_Algeria_2017SSD.7b92c58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/A2E_Algeria_2017SSD.jpg
// module id = 7qY9
// module chunks = 0